import React from "react";
import HelmetWrapper from "../../HelmetWrapper";
import TrainersRating from "../../components/trainers/TrainersRating";
import "../../styles/trainers/trainer-rating.css";

const TrainersRatingPage = () => {
  return (
    <HelmetWrapper title="WTF: Trainers">
      <TrainersRating />
    </HelmetWrapper>
  );
};

export default TrainersRatingPage;
